var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1-close",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.4.3-Health-screening-/-Upcoming-/-Reschedule---recheduled",
    transform: "translate(-1376.000000, -754.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Molecules/12.Web/06.Toast-banner/+Closeable",
    transform: "translate(1053.000000, 720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Molecules/01.Text/02.Sub/02.With-icon/Discription",
    transform: "translate(16.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-close",
    transform: "translate(307.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-close",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-close"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3257813,12 L17.0367188,8.28906248 C17.4034704,7.9229581 17.403995,7.32886094 17.0378907,6.96210935 C16.6717863,6.59535776 16.0776891,6.59483309 15.7109375,6.96093747 L12,10.671875 L8.28906248,6.96093747 C7.92231089,6.59418588 7.32768907,6.59418588 6.96093747,6.96093747 C6.59418588,7.32768907 6.59418588,7.92231089 6.96093747,8.28906248 L10.671875,12 L6.96093747,15.7109375 C6.59418588,16.0776891 6.59418588,16.6723109 6.96093747,17.0390625 C7.32768907,17.4058141 7.92231089,17.4058141 8.28906248,17.0390625 L12,13.328125 L15.7109375,17.0390625 C16.0776891,17.4058141 16.6723109,17.4058141 17.0390625,17.0390625 C17.4058141,16.6723109 17.4058141,16.0776891 17.0390625,15.7109375 L13.3257813,12 Z",
    id: "close",
    fill: "#666666",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.501c3d16.svg";
export { ForwardRef as ReactComponent };